import axios from "axios";

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    function (error) {
        if (error.response.status === 401) {
            window.location.href = `${process.env.VUE_APP_MAIN_MODULE_URL}/Evaluations/Index/${sessionStorage.evaluationsType}`;
        } else {
            return Promise.reject(error.response);
        }
    },
);

axios.interceptors.request.use(
    function (config) {
        config.headers.Authorization = `Bearer ${sessionStorage.jwt}`;
        return config;
    },
    function (error) {
        return Promise.reject(error);
    },
);

import Vue from "vue";
import Vuex from "vuex";
import contextModule from "./contextModule";
import dataModule from "./dataModule";
import tumourDataModule from "./tumourDataModule";
import rhinoDataModule from "./rhinoDataModule";
import ciDataModule from "./ciDataModule";
import tagDataModule from "./tagDataModule";
import kaplanMeierModule from "./kaplanMeierModule";
import treeListDataModule from "./treeListDataModule";
import patientsListDataModule from "./patientsListDataModule";

Vue.use(Vuex);

const QUERY_DISPLAY_VALUES = "QUERY_DISPLAY_VALUES";
const TIMEZONEOFFSET = "TIMEZONEOFFSET";
const UPDATE_RELATIONAL_QUERY = "UPDATE_RELATIONAL_QUERY";
const DELETE_RELATIONAL_QUERY = "DELETE_RELATIONAL_QUERY";
const REMOVE_ALL_FILTERS = "REMOVE_ALL_FILTERS";
const DATA_SHOULD_BE_RELOADED = "DATA_SHOULD_BE_RELOADED";
const AOQN_USER_ID = "AOQN_USER_ID";
const AOQN_USER_ROLE = "AOQN_USER_ROLE";

// STATE
const state = {
    queryDisplayValues: null,
    env: null,
    timezoneOffset: null,
    advancedQueryCriteria: {
        MrAttributes: Object.create({}),
    },
    patientQuery: Object.create({}),
    caseQuery: Object.create({}),
    mrAttributeQuery: Object.create({}),

    dataShouldBeReloaded: false,
    aoqnUserId: null,
    aoqnUserRole: "",
    isAdmin: false,
    isCoordinator: false
};

// MUTATIONS
const mutations = {
    [QUERY_DISPLAY_VALUES](state, queryDisplayValues) {
        state.queryDisplayValues = queryDisplayValues;
    },
    [TIMEZONEOFFSET](state, timezoneOffset) {
        state.timezoneOffset = timezoneOffset;
    },
    [UPDATE_RELATIONAL_QUERY](state, query) {
        Vue.set(state, query.category, {
            ...state[query.category],
            [query.queryField]: query.value,
        });
    },
    [DELETE_RELATIONAL_QUERY](state, query) {
        Vue.delete(state[query.category], query.queryField);
    },
    [REMOVE_ALL_FILTERS](state) {
        Vue.set(state, "patientQuery", {});
        Vue.set(state, "caseQuery", {});
        Vue.set(state, "advancedQueryCriteria", { MrAttributes: {} });
    },
    [DATA_SHOULD_BE_RELOADED](state, dataShouldBeReloaded) {
        state.dataShouldBeReloaded = dataShouldBeReloaded;
    },
    [AOQN_USER_ID](state, aoqnUserId) {
        state.aoqnUserId = aoqnUserId;
    },
    [AOQN_USER_ROLE](state, aoqnUserRole) {
        state.aoqnUserRole = aoqnUserRole;
        state.isAdmin = aoqnUserRole == "Administrator";
        state.isCoordinator = aoqnUserRole == "Coordinator";
    },
};

// ACTIONS
const actions = {
    setQueryDisplayValues({ commit }, queryDisplayValues) {
        return commit("QUERY_DISPLAY_VALUES", queryDisplayValues);
    },
    setTimezoneOffset({ commit }, timezoneOffset) {
        return commit("TIMEZONEOFFSET", timezoneOffset);
    },
    updateRelationalQuery({ commit }, query) {
        commit(UPDATE_RELATIONAL_QUERY, { ...query, category: query.category.toLowerCase() + "Query" });
    },
    deleteRelationalQuery({ commit }, query) {
        commit(DELETE_RELATIONAL_QUERY, { ...query, category: query.category.toLowerCase() + "Query" });
    },
    cleanFilters({ commit }) {
        commit(REMOVE_ALL_FILTERS);
    },
    setDataShouldBeReloaded({ commit }, dataShouldBeReloaded) {
        commit(DATA_SHOULD_BE_RELOADED, dataShouldBeReloaded);
    },
    setAoqnUserId({ commit }, aoqnUserId) {
        return commit(AOQN_USER_ID, aoqnUserId);
    },
    setAoqnUserRole({ commit }, aoqnUserRole) {
        return commit(AOQN_USER_ROLE, aoqnUserRole);
    },
};

const store = new Vuex.Store({
    state,
    mutations,
    actions
});

store.registerModule("contextModule", contextModule);
store.registerModule("dataModule", dataModule);
store.registerModule("tumourDataModule", tumourDataModule);
store.registerModule("rhinoDataModule", rhinoDataModule);
store.registerModule("ciDataModule", ciDataModule);
store.registerModule("tagDataModule", tagDataModule);
store.registerModule("kaplanMeierModule", kaplanMeierModule);
store.registerModule("treeListDataModule", treeListDataModule);
store.registerModule("patientsListDataModule", patientsListDataModule);

export default store;
